__turbopack_context__.v({
  "button": "open-access-info-module-scss-module__0aAotq__button",
});
